import React from 'react';
import * as XLSX from 'xlsx';

const ModuleDimensionCheck = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const moduleData = inspectionData.ModuleDimensionCheck;

  if (!moduleData || !moduleData.lines) {
    return <p className="text-gray-500">No Module Dimension Check data available</p>;
  }

  // Define all possible fields for the table and Excel
  const fields = [
    'sn',
    'backLong',
    'backShort',
    'coatingThickness',
    'deviationDiagonal',
    'groundingMark',
    'height',
    'hole1Length',
    'hole1Width',
    'hole2Length',
    'hole2Width',
    'hole3Length',
    'hole3Width',
    'longSide',
    'negativeCable',
    'noDrainHoles',
    'noGroundHoles',
    'positiveCable',
    'remarks',
    'result',
    'shortSideBottom',
    'shortSideMiddle',
    'shortSideTop',
    'xPitchBottomHole',
    'xPitchMiddleHole',
    'xPitchTopHole',
    'yPitch400',
    'yPitch1000',
    'yPitch1400',
  ];

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet (Line + all fields)
    worksheetData.push(['Line', ...fields.map((field) => field.replace(/([A-Z])/g, ' $1').trim())]);

    // Populate data for each line
    Object.entries(moduleData.lines).forEach(([lineKey, lineData]) => {
      const row = [lineKey];
      fields.forEach((field) => {
        row.push(lineData[field] || '');
      });
      worksheetData.push(row);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ModuleDimensionCheck');
    XLSX.writeFile(workbook, 'ModuleDimensionCheckData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Module Dimension Check - {moduleData.date}</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(moduleData.lines).map(([lineKey, lineData]) => (
        <div key={lineKey} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">{lineKey}</h3>

          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border rounded-lg">
              <thead>
                <tr className="bg-gray-100">
                  {fields.map((field) => (
                    <th key={field} className="px-4 py-2 text-left text-gray-700">
                      {field.replace(/([A-Z])/g, ' $1').trim()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="border-t">
                  {fields.map((field) => (
                    <td key={field} className="px-4 py-2 text-gray-600">
                      {lineData[field] || 'N/A'}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ModuleDimensionCheck;